module.exports = __webpack_public_path__ + "static/logo-d56f1d3b451b20d2e1da3a9c51690ce8.jpg";